import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Paper,
  Typography,
  Avatar,
  Grid,
  useMediaQuery,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction,
  Box,
} from "@material-ui/core";

import { UserRole } from "../constants";

import { APPROVAL_COLUMNS_ENHANCED, APPROVAL_PROP } from "./constants";
import approvalActions from "./actions";
import TableActions from "./TableActions";
import useStyles from "../UserTable/UserTableStyles";
import EnhancedTableHead from "components/common/EnhancedTableHead";

const ApprovalsTable = () => {
  const classes = useStyles();
  const { setEditApproval, loadApprovals, setOrderBy, setPagination } =
    approvalActions();
  const { approvals, table, total } = useSelector((state) => state.approvals);
  const { role } = useSelector((state) => state.auth);

  useEffect(() => {
    loadApprovals();
  }, [loadApprovals, table]);

  const handleRequestSort = (event, property) => {
    const isAsc = table.orderBy.order === "asc";
    setOrderBy({ col: property, order: isAsc ? "desc" : "asc" });
  };

  const handleChangePage = (event, newPage) => {
    setPagination({
      limit: table.limit,
      offset: newPage * table.limit,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination({ limit: parseInt(event.target.value), offset: 0 });
  };

  const headCells = [...APPROVAL_COLUMNS_ENHANCED];

  if (role === UserRole.SUPERADMIN) {
    headCells.push({
      id: "actions",
      label: "Action",
      numeric: false,
      disablePadding: false,
      disableSort: true,
    });
  }
  const rowsPerPage = table.limit;
  const getAvatar = (row) => {
    return (
      <Avatar className={classes.AvatarSmall}>
        <Typography className={classes.AvatarText}>
          {row[APPROVAL_PROP.FNAME][0].toUpperCase() +
            row[APPROVAL_PROP.LNAME][0].toUpperCase()}
        </Typography>
      </Avatar>
    );
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  const emptyRows = rowsPerPage - approvals.length;
  return (
    <Paper className={classes.paper}>
      {matches ? (
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              columns={headCells}
              classes={classes}
              order={table.orderBy.order}
              orderBy={table.orderBy.col}
              onRequestSort={handleRequestSort}
              rowCount={total}
            />
            <TableBody>
              {approvals.map((row) => {
                return (
                  <TableRow
                    onClick={() =>
                      setEditApproval({
                        ...row,
                      })
                    }
                    tabIndex={-1}
                    key={row.id}
                  >
                    <TableCell scope="row">
                      <Grid container alignItems="center" direction="row">
                        {getAvatar(row)}
                        <Typography>
                          {`${row[APPROVAL_PROP.FNAME]} ${
                            row[APPROVAL_PROP.LNAME]
                          }`}
                        </Typography>
                      </Grid>
                    </TableCell>
                    <TableCell>{row[APPROVAL_PROP.EMAIL]}</TableCell>
                    <TableCell>{row[APPROVAL_PROP.DETAILS]}</TableCell>
                    {role === UserRole.SUPERADMIN && (
                      <TableCell>
                        <TableActions />
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 48 * emptyRows,
                  }}
                >
                  <TableCell />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <List>
          {approvals.map((row) => {
            return (
              <ListItem key={row.id}>
                <ListItemAvatar>{getAvatar(row)}</ListItemAvatar>
                <ListItemText
                  primary={`${row[APPROVAL_PROP.FNAME]} ${
                    row[APPROVAL_PROP.LNAME]
                  }`}
                  secondary={
                    row[APPROVAL_PROP.EMAIL] +
                    " • " +
                    row[APPROVAL_PROP.DETAILS]
                  }
                />
                {role === UserRole.SUPERADMIN && (
                  <ListItemSecondaryAction>
                    <Box
                      edge="end"
                      onClick={() =>
                        setEditApproval({
                          ...row,
                        })
                      }
                    >
                      <TableActions />
                    </Box>
                  </ListItemSecondaryAction>
                )}
              </ListItem>
            );
          })}
        </List>
      )}
      <TablePagination
        rowsPerPageOptions={matches ? [10, 20, 30] : [10]}
        component="div"
        count={total}
        rowsPerPage={table.limit}
        page={table.offset / table.limit}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default ApprovalsTable;
